import { apiClient } from '@/lib/api'
import type {
  AddOnCatalogItem,
  AddOnCatalogWriteBody,
  DealAddOn,
  DealAddOnWriteBody,
} from '@/types/addon'

// --- Catalog (price book) ---

export const fetchAddOnCatalog = async (filters?: {
  q?: string
  category?: string
  boat_type?: string
  active?: boolean
}): Promise<AddOnCatalogItem[]> => {
  return apiClient<AddOnCatalogItem[]>('/addon-catalog', { params: filters })
}

export const createAddOnCatalogItem = async (
  body: AddOnCatalogWriteBody,
): Promise<AddOnCatalogItem> => {
  return apiClient<AddOnCatalogItem>('/addon-catalog', { method: 'POST', body })
}

export const updateAddOnCatalogItem = async (
  id: string,
  body: Partial<AddOnCatalogWriteBody>,
): Promise<AddOnCatalogItem> => {
  return apiClient<AddOnCatalogItem>(`/addon-catalog/${id}`, { method: 'PUT', body })
}

export const deleteAddOnCatalogItem = async (id: string): Promise<void> => {
  return apiClient<void>(`/addon-catalog/${id}`, { method: 'DELETE' })
}

// --- Deal add-on lines ---

export const fetchDealAddOns = async (dealId: string): Promise<DealAddOn[]> => {
  return apiClient<DealAddOn[]>(`/deals/${dealId}/addons`)
}

// The deal id rides in the variables (not a closure) so an offline replay
// can rebuild the request path after a reload.
export const addDealAddOn = async (vars: {
  dealId: string
  body: DealAddOnWriteBody
}): Promise<DealAddOn> => {
  return apiClient<DealAddOn>(`/deals/${vars.dealId}/addons`, { method: 'POST', body: vars.body })
}

// Line edits go by the line's own id (it carries its deal server-side).
export const updateDealAddOn = async (
  lineId: string,
  body: Partial<DealAddOnWriteBody>,
): Promise<DealAddOn> => {
  return apiClient<DealAddOn>(`/deal-addons/${lineId}`, { method: 'PUT', body })
}

export const deleteDealAddOn = async (lineId: string): Promise<void> => {
  return apiClient<void>(`/deal-addons/${lineId}`, { method: 'DELETE' })
}
